import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const CIOPageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (window.cioanalytics) {
      window.cioanalytics.page(location.pathname, {
        url: window.location.href,
        title: document.title
      });
    }
  }, [location.pathname]);

  return null;
};
export default CIOPageTracker;
